import { createServerFn } from "@tanstack/react-start"
import { getCookie, setCookie } from "@tanstack/react-start/server"
import { AUTH_COOKIE_MAX_AGE_SECONDS } from "@mylaunch/payload/auth"
import {
  sendOTP as sendOTPService,
  verifyOTP as verifyOTPService,
  deleteCurrentAccount as deleteCurrentAccountService,
  isLoggedIn as isLoggedInService,
  getCurrentUserId,
} from "@apps/gwservice/auth"
import { bumpHandoffTokenVersion } from "@apps/gwservice/handoff"
import { ctx } from "@mylaunch/utils/logs"
import { withAuth } from "./auth"


export const isLoggedIn = createServerFn({
  method: "GET",
}).handler(async () => {
  if (!getCookie("payload-token")) return false

  const valid = await withAuth(isLoggedInService)()
  if (valid) return true

  setCookie("payload-token", "", {
    httpOnly: true,
    maxAge: 0,
    path: "/",
    sameSite: "lax",
  })
  ctx({ reason: "cookie_present_user_null" })
  throw new Error("session_invalid")
})

export const sendOTP = createServerFn({
  method: "POST",
})
  .inputValidator((data: { phone: string }) => data)
  .handler(({ data }) => sendOTPService(data.phone))

export const verifyOTP = createServerFn({
  method: "POST",
})
  .inputValidator((data: { phone: string; code: string }) => data)
  .handler(async ({ data }) => {
    const result = await verifyOTPService(data.phone, data.code)

    if (typeof result === "object" && result !== null && "id" in result && "token" in result) {
      setCookie("payload-token", result.token, {
        httpOnly: true,
        maxAge: AUTH_COOKIE_MAX_AGE_SECONDS,
        path: "/",
        sameSite: "lax",
      })
    }

    return result
  })

export const deleteAccount = createServerFn({
  method: "POST",
}).handler(() => withAuth(deleteCurrentAccountService)())

export const logout = createServerFn({
  method: "POST",
}).handler(async () => {
  const userId = await getCurrentUserId().catch(() => undefined)
  if (userId) {
    await bumpHandoffTokenVersion(userId).catch(() => undefined)
  }
  setCookie("payload-token", "", {
    httpOnly: true,
    maxAge: 0,
    path: "/",
    sameSite: "lax",
  })
})
